<div class="tabs-container" [class]="customClass">
  <div 
    *ngFor="let tab of tabs; trackBy: trackByIndex" 
    class="tab-item" 
    [ngClass]="{ 'active': isTabActive(tab.id) }" 
    (click)="onTabClick(tab.id)">
    <span>{{ tab.label }}</span>
  </div>
</div>
